import { render, staticRenderFns } from "./enclosureDialog.vue?vue&type=template&id=534016c9"
import script from "./enclosureDialog.vue?vue&type=script&lang=js"
export * from "./enclosureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports